module.exports = __webpack_public_path__ + "static/media/Eye.80ae4cb2.svg";